import { css } from "@emotion/react"
import React, { useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"

export function DemoInlineSectionWithPic({ title, bg, color }: { title: string; bg: string; color: string }) {
  const [sended, setSended] = useState(false)
  const box = css`
    color: ${color};
    background-color: ${bg};
    border-radius: 1.25rem;
  `

  return (
    <section className="consultation">
      <Container>
        <Row>
          <Col>
            <div css={box}>
              <Row className="px-4 px-md-5 px-lg-4 align-items-center align-items-lg-stretch">
                <Col lg={7} xl={6} css={leftCol} className="py-5 p-lg-5">
                  {((!sended || !isWeekend) && <div dangerouslySetInnerHTML={{ __html: title }} />) || (
                    <>
                      <p>Мы получили заявку! Наши менеджеры перезвонят вам в понедельник с 10:00 до 12:00</p>
                      <div className="h3 mb-4">
                        Чтобы вы не грустили в ожидании звонка, мы дарим вам готовые сценарии использования поп‑апов и чат-бота, которые помогут вашему бизнесу
                        зарабатывать больше
                      </div>
                    </>
                  )}
                  <a href="#open-demo-pop-up" className="btn btn-primary btn-demo">
                    Заказать демо
                  </a>
                </Col>

                <ColPic />
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

DemoInlineSectionWithPic.defaultProps = {
  bg: "#5c5cd6",
  color: "#fff",
}

// Проверяем день недели и определяем выходные
const yourDateObject = new Date()
const date = yourDateObject.getDate()
const day = yourDateObject.getDay()
const isWeekend = day === 6 || day === 0 // 6 = Saturday, 0 = Sunday

const leftCol = css`
  .afterSendWeekend p {
    display: none;
  }

  .btn {
    margin-top: 0 !important;
    height: auto !important;
    @media (min-width: 1400px) {
      padding: 1rem 2rem;
    }
    @media (max-width: 575.98px) {
      line-height: 1rem;
    }
  }
`

const ColPic = () => (
  <Col lg={5} xl={6} className="d-none d-lg-block pb-5 pe-5 text-center">
    <StaticImage src="./assets/cq-demo.png" width={800} alt="Demo" className="mx-auto mb-auto" />
  </Col>
)
